const socialLinks = [
  { icon: 'fab fa-behance', href: '#' },
  { icon: 'fab fa-dribbble', href: '#' },
  { icon: 'fab fa-twitter', href: '#' },
  { icon: 'fab fa-github', href: '#' },
]

export default function Sidebar({ pageName }) {
  return (
    <div className="mil-left-panel">
      <div className="mil-page-name mil-upper mil-dark">{pageName}</div>

      <ul className="mil-social-icons">
        {socialLinks.map((s) => (
          <li key={s.icon}>
            <a href={s.href} target="_blank" rel="noreferrer" className="social-icon">
              <i className={s.icon}></i>
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
